import { trim } from './string';

export const isItemUrl = (_path: string) => {
  const path = trim(_path || location.pathname, '/');
  const parts = path.split('/');
  const isItemUrl = parts.length >= 2 && parts[0] === 'objekt';
  return isItemUrl;
};
